<template>
  <v-card-text class="d-flex flex-column justify-center chargeback-price-config-list">
    <p
      v-for="(priceConfig, index) in chargebackEventPrices"
      :key="index"
      class="d-flex w-full align-center justify-space-between mb-2"
    >
      <span v-if="chargebackEventPrices.length > 1" class="text-subtitle-1 font-weight-light">
        {{ priceConfig.tier }}:
      </span>
      <span class="text-subtitle-1 font-weight-bold">{{ priceConfig.price }} EUR</span>
    </p>
  </v-card-text>
</template>

<script>
export default {
  props: {
    chargebackEventPrices: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.chargeback-price-config-list {
  min-height: 10rem;
}
</style>
